/**
 * Shapes Animations - Safe Version (prevents duplicate declarations)
 */

// Only declare if not already defined
if (typeof window.ShapesAnimations === 'undefined') {
  
  class ShapesAnimations {
    constructor() {
      this.parallaxItems = [];
      this.rotateItems = [];
      this.observers = new Map();
      this.listeners = new Map();
      this.animationFrame = null;
      this.isAnimating = false;
      this.screenHeight = window.innerHeight;
      this.intensity = 1;
      
      // Bind methods
      this.animate = this.animate.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.cleanup = this.cleanup.bind(this);
      
      this.init();
    }
    
    init() {
      // Reduced functionality to prevent performance issues
      console.log('ShapesAnimations: Safe mode initialized');
      
      // Add minimal cleanup on page unload
      window.addEventListener('beforeunload', this.cleanup);
    }
    
    cleanup() {
      // Cancel any running animations
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }
      
      // Clear all observers
      this.observers.forEach(observer => observer.disconnect());
      this.observers.clear();
      
      // Remove all listeners
      this.listeners.forEach((listener, element) => {
        element.removeEventListener('scroll', listener);
        element.removeEventListener('resize', listener);
      });
      this.listeners.clear();
      
      // Clear arrays
      this.parallaxItems = [];
      this.rotateItems = [];
      
      console.log('ShapesAnimations: Cleaned up');
    }
    
    // Minimal methods to prevent errors
    handleScroll() {
      // Disabled for performance
    }
    
    handleResize() {
      this.screenHeight = window.innerHeight;
    }
    
    animate() {
      // Disabled for performance
    }
  }
  
  // Make it globally available
  window.ShapesAnimations = ShapesAnimations;
  
  // Auto-initialize only once
  if (!window.shapesAnimationsInstance) {
    window.shapesAnimationsInstance = new ShapesAnimations();
  }
  
} else {
  console.log('ShapesAnimations: Already loaded, skipping');
}